import AssociationAccountService from "../../services/association/AssociationAccountService";
import dayjs from "dayjs";
import {notification} from "antd";
import {t} from "i18next";
import {MEMBER} from "../../constants/UserAssociationRolesConstant";

const getAssociationAccounts = async (search, page, id) => {
    return AssociationAccountService.getAccountByAssociation(search.status, page, id);
}


const getAssociationAccountsForClose = async (search, page, id) => {
    return AssociationAccountService.getAccountByAssociationForClose(
        page, id, search.referenceNumber, search.association
    );
}

const sendBillAgainAssociationAccount = async (id) => {
    return AssociationAccountService.sendBillAgain(id);
}

const getOneAssociationAccount = async (id) => {
    return AssociationAccountService.getOne(id);
}

const getByAssociationBankStatementItem = async (id) => {
    return AssociationAccountService.getByAssociationBankStatementItem(id);
}

const createAssociationAccountManually = async (values, associationId) => {
    const currentYear = dayjs().year();
    const currentDate = dayjs().format('YYYYMMDD');
    try {
        return await AssociationAccountService.createManually({
            associationId: parseInt(associationId),
            referenceNumber: `${associationId}-${currentYear}-${currentDate}-${values.referenceNumber}`,
            dueDate: values.dueDate,
            dateOfAccountCreation: values.dateOfAccountCreation,
            description: values.description,
            items: values.items,
            paidAmount: values.paidAmount
        });
    } catch (err) {
        return false;
    }
}

const updateAssociationAccountManually = async (values, associationAccountId, associationId) => {
    try {
        return await AssociationAccountService.updateManually({
            dueDate: values.dueDate,
            dateOfAccountCreation: values.dateOfAccountCreation,
            dateOfPayment: values.dateOfPayment,
            description: values.description,
            items: values.items,
            paidAmount: String(values.paidAmount),
            associationId: parseInt(associationId),
            accountNumber: values.accountNumber
        }, associationAccountId);
    } catch (err) {
        return false;
    }
}

const cancelAssociationAccount = async (canceled, associationId) => {
    try {
        return await AssociationAccountService.setCanceled({
            isCanceled: canceled
        }, associationId);
    } catch (err) {
        return false;
    }
}

const closeManually = async (bankStatementItemId, associationAccountId) => {
    try {
        return await AssociationAccountService.closeManually(bankStatementItemId, associationAccountId);
    } catch (err) {
        return false;
    }
}

export const checkAssociationAccountDebt = (response, navigate, currentFull) => {
    if (!response?.association?.accountDebt) return
    const targetPath = '/app/associationAccounts/index'
    if (currentFull === targetPath) return
    for (const { roleIndicator } of response.associationRoles || []) {
        if (roleIndicator !== MEMBER) {
            notification.warning({
                message: t('association.disconnected.debt'),
                duration: 6
            });
            navigate(targetPath)
            return
        }
    }
}

export {
    getAssociationAccounts,
    getByAssociationBankStatementItem,
    getOneAssociationAccount,
    sendBillAgainAssociationAccount,
    cancelAssociationAccount,
    updateAssociationAccountManually,
    createAssociationAccountManually,
    closeManually,
    getAssociationAccountsForClose
};